import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Card, CardHeader } from 'reactstrap'
import { fetchUsersManagerApproval } from 'store/Users/actions'
import { fetchUsersGroupManagerApproval } from 'store/Users/actions'
import defaultAvatar from '../../../../../assets/img/brand/img_avatar.png'
import { Link } from 'react-router-dom'
import './style.css'
import { setManagerApprovalFetched } from 'store/Dashboard/actions'
function ManagerAlert() {
  const dispatch = useDispatch()

  const { groupManagerApprovalUsers, managerApprovalUsers } = useSelector(
    (state) => state.users
  )

  const { managerApprovalFetched } = useSelector((state) => state.dashboard)

  const [alertType, setAlert] = useState('course')
  const changeAlertType = () => {
    if (alertType === 'course') {
      setAlert('group')
    } else {
      setAlert('course')
    }
  }

  useEffect(() => {
    if (managerApprovalFetched) return
    dispatch(fetchUsersGroupManagerApproval())
    dispatch(fetchUsersManagerApproval())
    dispatch(setManagerApprovalFetched(true))
  }, [dispatch, managerApprovalFetched])

  return (
    <Card className='h-100 scrollbar' style={{ overflowY: 'scroll' }}>
      <CardHeader className='border-0'>
        <h3 className='mb-0'>Manager Alert</h3>
        <div className='d-flex mt-2'>
          <div className='mr-3'>
            <input
              type='radio'
              checked={alertType === 'course'}
              onChange={changeAlertType}
              className='my-2'
              value={'courseAlert'}
              id={'courseAlert'}
            />
            <label className='m-2' htmlFor={'courseAlert'}>
              Course
            </label>
          </div>
          <div className=''>
            <input
              type='radio'
              checked={alertType === 'group'}
              onChange={changeAlertType}
              className='my-2'
              value={'groupAlert'}
              id={'groupAlert'}
            />
            <label className='m-2' htmlFor={'groupAlert'}>
              Group
            </label>
          </div>
        </div>
      </CardHeader>
      <div className='d-flex items-center justify-content-between px-4'>
        <p className='font-weight-bold text-black'>name</p>
        <p className='font-weight-bold text-black'>{alertType}</p>
      </div>
      <div className='d-flex flex-column px-1 mt-3'>
        {alertType === 'course' &&
          managerApprovalUsers &&
          managerApprovalUsers.length &&
          managerApprovalUsers.map((user) => (
            <div
              key={`${user.user_id}${user.course_id}`}
              className='d-flex items-center justify-content-between'
              style={{ marginBottom: '5px' }}
            >
              <div
                className='d-flex items-center'
                style={{ marginLeft: '10px' }}
              >
                <img
                  alt='user'
                  className='leaderboard-avatar'
                  src={
                    user.avatar ? JSON.parse(user.avatar).url : defaultAvatar
                  }
                />
                <Link
                  to={`/manager-reports/employee/${
                    user && user.user_id
                  }/checklist?course_id=${
                    user && user.course_id
                  }&referred_from_manager_report=true&from_dashboard`}
                  className='mt-2 pl-2 name'
                >
                  {user && user.first_name} {user && user.last_name}
                </Link>
              </div>
              <p
                style={{
                  marginRight: '10px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {user.name}
              </p>
            </div>
          ))}
        {alertType === 'group' &&
          groupManagerApprovalUsers &&
          groupManagerApprovalUsers.map((user) => (
            <div
              key={`${user.user_id}${user.course_id}`}
              className='d-flex items-center justify-content-between'
            >
              <div className='d-flex items-center'>
                <img
                  alt='user'
                  className='leaderboard-avatar'
                  src={
                    user.avatar ? JSON.parse(user.avatar).url : defaultAvatar
                  }
                />
                <Link
                  to={`/manager-reports/employee/${
                    user && user.user_id
                  }/checklist?group_id=${
                    user && user.group_id
                  }&referred_from_manager_report=true&from_dashboard`}
                  className='mt-2 pl-2'
                >
                  {user && user.first_name} {user && user.last_name}
                </Link>
              </div>
              <p>{user.name}</p>
            </div>
          ))}
      </div>
    </Card>
  )
}

export default ManagerAlert
